import cx from 'classnames';
import Image from 'common/components/Image';
import React from 'react';
import { useHoverDirty } from 'react-use';

const HoverablePreferences: React.FC = () => {
  const ref = React.useRef<HTMLDivElement>(null);
  const isHovering = useHoverDirty(ref);

  return (
    <div ref={ref}>
      <Image
        className={cx('icon-preferences', isHovering && 'active')}
        alt="Toggle Preferences"
      />
    </div>
  );
};

export default HoverablePreferences;
